import React, { useEffect } from 'react';
import annotationPlugin from 'chartjs-plugin-annotation';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  Filler,
  ArcElement
} from 'chart.js';
import { Bar, Line, Doughnut } from 'react-chartjs-2';

import { BarChart as RootBarChart, LineChart, ChartsTooltip  } from '@mui/x-charts';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  Filler,
  ArcElement,
  annotationPlugin
);

const def_options = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
    },
    title: {
      display: false,
      text: 'Chart.js Bar Chart',
    },
    annotation: {
      annotations: {
        label1: {
          type: 'label',
          xValue: 2,
          yValue: .5,
          backgroundColor: 'rgba(245,245,245,0)',
          content: ['Categoria: Taglio', 'Appuntamenti: 3'],
          font: {
            size: 14
          },
        }
      }
    }
  },
};

const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];

const def_data = {
  labels,
  datasets: [
    {
      label: 'Dataset 1',
      data: [12, 3, 12, 4, 22, 1, 7],
      backgroundColor: 'rgba(255, 99, 132, 0.5)',
    },
    {
      label: 'Dataset 2',
      data: [12, 3, 22, 4, 2, 11, 7],
      backgroundColor: 'rgba(53, 162, 235, 0.5)',
    },
  ],
};

export const BarChart = ({ options = def_options, data = def_data }) => {
  return (
    <RootBarChart
      xAxis={[
        {
          id: 'barCategories',
          data: data.labels,
          scaleType: 'band',
        },
      ]}
      slots={{
        itemContent: CustomItemTooltip,
        axisContent: CustomItemTooltip
      }}
      slotProps={{
        axisContent: {labels: data.tooltipLabels},
        itemContent: {labels: data.tooltipLabels}
      }}
      series={data.datasets}
    />
  )
}

const CustomItemTooltip=(props)=>{
  // console.log(props)
  return(
    <div className='statistics-graph-tooltip-container'>
      <p className='nac-text statistics-graph-tooltip-header'>{props.axisValue}</p>
      <span className='nac-text statistics-graph-tooltip-body'>{props.series.length>0?props.series[0].label:"Error"}: {props.labels[props.dataIndex]}</span>
    </div>
  )
}

export const AreaChart = ({ options = def_options, data = def_data }) => {
  return (
    <LineChart
    xAxis={[
      {
        id: 'barCategories',
        data: data.labels,
        scaleType: 'band',
      },
    ]}
    
    slots={{
      itemContent: CustomItemTooltip,
      axisContent: CustomItemTooltip
    }}
    slotProps={{
      axisContent: {labels: data.tooltipLabels},
      itemContent: {labels: data.tooltipLabels}
    }}
      series={data.datasets}
    />
  )
}

export const DonutChart = ({ options = def_options, data = def_data }) => {
  return <Doughnut options={options} data={data} />;
}